<header class="header">
  <hdi-top-bar-loader></hdi-top-bar-loader>
</header>
<div class="main">
  <hdi-section>
    <hdi-newsticker-loader></hdi-newsticker-loader>
  </hdi-section>
  <hdi-section>
    <hdi-home-stage-loader></hdi-home-stage-loader>
  </hdi-section>
  <!-- Main Section -->
  <hdi-section [backgroundColor]="'grey'">
    <hdi-teaser-container-loader></hdi-teaser-container-loader>
  </hdi-section>
  <hdi-section>
    <hdi-teaser-container-loader></hdi-teaser-container-loader>
    <hdi-help-disruptor-loader></hdi-help-disruptor-loader>
    <hdi-cross-referencing-loader></hdi-cross-referencing-loader>
  </hdi-section>
  <hdi-section [backgroundColor]="'grey'">
    <hdi-teaser-container-loader></hdi-teaser-container-loader>
    <hdi-cross-referencing-loader></hdi-cross-referencing-loader>
  </hdi-section>
  <hdi-section>
    <hdi-prefooter-loader></hdi-prefooter-loader>
  </hdi-section>
</div>
<footer class="footer">
  <div class="container">
    <hdi-footer-loader></hdi-footer-loader>
  </div>
</footer>
